<ng-template #customerDetailsRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Customer Details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="table-responsive">
			<table class="table table-fixed table-striped table-hover w-100" *ngIf="customerdetails?.length">
				<thead class="thead-dark sticky-header">
					<tr>
						<th>Date</th>
						<th>Item</th>
						<th>Desc</th>
						<th>Qty</th>
						<th>Price</th>
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let i of customerdetails">
						<td>{{ i.date_added }}</td>
						<td>{{ i.stockid }}</td>
						<td>{{ i.name }}</td>
						<td>{{ i.quantity }}</td>
						<td>{{ i.price | currency }}</td>
						<td>{{ i.price * i.quantity | currency }}</td>
					</tr>
				</tbody>
			</table>
			<h4 class="text-center mt-3" *ngIf="!customerdetails?.length">No Records Found</h4>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<div class="container-fluid tp-box" [@flipState]="flip">
	<!-- FRONT VIEW -->
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-info card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(topcustomers, title)">
					<i class="material-icons">stars</i>
				</div>
				<p class="card-category">{{ title }}</p>
				<h3 class="card-title mt-2 mb-0">
					<span *ngIf="loading">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					<span *ngIf="!loading">{{ topcustomers.length }}</span>
					<br /><br />
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(topcustomers, title)">
						<i class="material-icons">visibility</i> View Now
					</a>
				</div>
			</div>
		</div>
	</div>

	<!-- BACK VIEW -->
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card top-customers-expanded w-100">
			<div class="card-header card-header-info card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')" title="Back">
					<i class="material-icons">arrow_back</i>
				</div>
				<h3 class="card-title mb-0">Top {{ reportLimit }} Customers</h3>
			</div>

			<div class="card-body">
				<form [formGroup]="searchForm" class="top-customers-form">
					<div class="tc-toolbar">
						<mat-form-field appearance="outline" class="tc-date-range">
							<mat-label>Transaction dates</mat-label>
							<mat-date-range-input [rangePicker]="picker">
								<input matStartDate formControlName="fromDateCtrl" placeholder="Start" />
								<input matEndDate formControlName="toDateCtrl" placeholder="End" />
							</mat-date-range-input>
							<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-date-range-picker #picker></mat-date-range-picker>
						</mat-form-field>

						<mat-form-field appearance="outline" class="tc-limit-field">
							<mat-label>Limit</mat-label>
							<input matInput type="number" formControlName="limit" min="1" max="500" (change)="reloadCustomers()" />
						</mat-form-field>

						<button mat-raised-button color="accent" type="button" (click)="reloadCustomers()" [disabled]="loading">
							<mat-icon>refresh</mat-icon> Refresh
						</button>
						<button mat-raised-button class="btn-success" type="button" (click)="exportXls()" [disabled]="loading">
							<i class="fa fa-file-excel-o"></i> XLS
						</button>
						<button mat-raised-button color="warn" type="button" (click)="exportPdf()" [disabled]="loading">
							<i class="fa fa-file-pdf-o"></i> PDF
						</button>

						<span *ngIf="loading" class="tc-spinner" aria-hidden="true">
							<svg class="spinner" width="28" height="28" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</span>
					</div>

					<div class="tc-filter-row">
						<mat-form-field *ngIf="!issalesman" appearance="outline" class="tc-filter-field">
							<mat-label>Salespeople</mat-label>
							<mat-select formControlName="salesperson" multiple appSelectAll (selectionChange)="reloadCustomers()">
								<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">{{ sp.salesmanname }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="outline" class="tc-filter-field">
							<mat-label>Brands</mat-label>
							<mat-select formControlName="brand" multiple appSelectAll>
								<mat-option *ngFor="let v of brands" [value]="v.manufacturer_id">{{ v.name }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="outline" class="tc-filter-field">
							<mat-label>Categories</mat-label>
							<mat-select formControlName="category" multiple appSelectAll>
								<mat-option *ngFor="let v of categories" [value]="v.categoryid">{{ v.categoryid }} — {{ v.categorydescription }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="outline" class="tc-filter-field">
							<mat-label>Product lines</mat-label>
							<mat-select formControlName="prodline" multiple appSelectAll>
								<mat-option *ngFor="let v of productlines" [value]="v.line_field">{{ v.line_description }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</form>

				<p *ngIf="!loading && (!viewing || viewing.length === 0)" class="text-muted mb-0 mt-3">No customers match the current filters.</p>

				<div class="tc-list" *ngIf="viewing?.length">
					<!-- Header row -->
					<div class="tc-list-header">
						<span class="tc-col-rank">#</span>
						<span class="tc-col-name">Customer</span>
						<span class="tc-col-contact">Contact</span>
						<span class="tc-col-phone">Phone</span>
						<span class="tc-col-email">Email</span>
						<span class="tc-col-last">Last seen</span>
						<span class="tc-col-sales text-end">Sales total</span>
						<span class="tc-col-units text-end">Units</span>
					</div>

					<div class="tc-row" *ngFor="let d of viewing; let i = index">
						<span class="tc-col-rank">
							<span class="tc-rank-badge" [ngClass]="{'tc-rank-gold': i === 0, 'tc-rank-silver': i === 1, 'tc-rank-bronze': i === 2}">
								{{ i + 1 }}
							</span>
						</span>

						<span class="tc-col-name">
							<a [routerLink]="['/customers/view/', d.debtorno]" class="tc-customer-name">
								{{ d.name || d.deliverto }}
							</a>
							<span class="tc-customer-id">{{ d.debtorno }}.{{ d.branchcode }}</span>
						</span>

						<span class="tc-col-contact">{{ d.contactname || '—' }}</span>

						<span class="tc-col-phone">{{ d.phoneno || '—' }}</span>

						<span class="tc-col-email">
							<a *ngIf="d.email" [href]="'mailto:' + d.email" class="tc-email-link" [title]="d.email">{{ d.email }}</a>
							<span *ngIf="!d.email">—</span>
						</span>

						<span class="tc-col-last">{{ d.lastseen || '—' }}</span>

						<span class="tc-col-sales text-end">
							<strong>{{ d.salestotal | currency }}</strong>
						</span>

						<span class="tc-col-units text-end">{{ d.qtytotal | number }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
